import React, { Component } from "react";
import { connect } from "react-redux";
import { getAllQuestions } from "../../actions/question";
import { listPrograms, getFeed } from "../../actions/user";

class WithInitialData extends Component {
  componentDidMount() {
    if (this.props.userLoggedIn) {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.userLoggedIn !== this.props.userLoggedIn &&
        this.props.userLoggedIn) ||
      prevProps.selectedProgram !== this.props.selectedProgram
    ) {
      this.fetchData();
    }
  }

  fetchData = () => {
    this.props.getAllQuestions();
    this.props.listPrograms();
    this.props.getFeed();
  };

  render() {
    return this.props.children({});
  }
}

const mstp = state => ({
  selectedProgram: state.user.payload.selectedProgram,
  userLoggedIn: !!state.user.payload.token
});

const mdtp = dispatch => ({
  getAllQuestions: () => dispatch(getAllQuestions()),
  listPrograms: () => dispatch(listPrograms()),
  getFeed: () => dispatch(getFeed())
});

export default connect(
  mstp,
  mdtp
)(WithInitialData);



// WEBPACK FOOTER //
// ./src/components/HOC/WithInitialData.js